import styled from '@emotion/styled';
import { colors, heapTrack } from '@modernanimal/common';
import posthog from 'posthog-js';
import useBreakpoint from 'use-breakpoint';

import PrimaryButton from '../../components/PrimaryButton';
import { BREAKPOINTS } from '../../helpers';

const TestNextStepButton = (props: {
    disabled: boolean;
    loading?: boolean;
    onClick: ()=> void;
}) => {
    const { disabled, loading = false, onClick } = props;

    const { breakpoint } = useBreakpoint(BREAKPOINTS, 'desktop');
    const isMobile = breakpoint === 'mobile';

    const handleClick = () => {
        heapTrack('Web Booking - Select Appointment View - Next Button Clicked');
        posthog.capture('web_booking_click', { screen: 'SelectAppointment', action: 'NextButtonClicked' });
        onClick();
    };

    return (
        <NextButtonContainer isMobile={isMobile}>
            <PrimaryButton
                id="test-select-appointment-button"
                color="periwinkle"
                onClick={handleClick}
                disabled={disabled}
                loading={loading}
            >
                Confirm Booking
            </PrimaryButton>
        </NextButtonContainer>
    );
};

export default TestNextStepButton;

const NextButtonContainer = styled.div<{ isMobile: boolean }>`
    display: flex;
    position: ${({ isMobile }) => (isMobile ? 'sticky' : 'static')};
    bottom: 0px;
    background-color: ${({ isMobile }) => (isMobile ? 'transparent !important' : colors.WHITE)};
    ${({ isMobile }) => (isMobile ? 'padding: 16px 0 5% 0' : 'padding: 16px 0 32px 0')};
    ${({ isMobile }) => isMobile && `
        flex-direction: row-reverse; 
        
        button {
            width: unset; 
            height: unset;
            padding: 16px 32px;
            border-radius: 40px;
            position: relative;
            right: -3%;
        }   
    `}
`;
